<!-- Steppers go here after refactoring the stepper to be shared in the app -->
<app-shared-stepper-indicator
  [currentUserStep$]="currentUserStep$"
  [allowedUserSteps]="allowedUserSteps"
></app-shared-stepper-indicator>

<!-- Inject the right component here -->
<ng-template #outlet></ng-template>
